import React, { useState } from 'react';
import { Input } from 'antd';
import { useQueryClient } from 'react-query';
import Modal from '../../../components/Modal';
import { useReturn } from '../../../core/modules/book/hooks/useReturn.query';
import { IBook } from '../../../section/Common/types/types';
import { useActions } from '../../../context/Actions.context';
import { useServices } from '../../../core/services/useServices';
import Endpoints, { SEND_TO_CRM, SENT_TO_CRM_AO3, SENT_TO_CRM_RR } from '../../../core/constants/endpoints';
import showActionNotification from '../../../section/Common/utils/showActionNotification';
import { SOURCE } from '../../../core/constants';
import { useHistory } from 'react-router-dom';


const { TextArea } = Input;

interface IProps {
  book: IBook | Record<string, string | number>;
  modal: boolean;
  toggleModal: Function;
  id: string;
}

const ReturnTitles: React.FC<IProps> = ({ book, modal, toggleModal, id }) => {
  const { source, isActionLoading, setActionLoading } = useActions();
  const { book: bookService } = useServices();
  const queryClient = useQueryClient();
  const history = useHistory();
  const sourceId = {
    [SOURCE.bookstat]: book.ASIN,
    [SOURCE.ao3]: book['work_id'],
    [SOURCE['royal-road']]: book['Fiction Id']
  };

  const book_ids = sourceId[source?.['source']];
  const [notes, setNotes] = useState<string>('');

  const { mutateAsync } = useReturn({ book_ids, tabId: id, source: source['source'] });

  const handleClose = () => {
    setNotes('');
    toggleModal();
  };

  const onSend = () => {
    setActionLoading(true);

    const body = {
      ...(notes.trim() && { notes: notes.trim() })
    };

    const capturedSource = source['source'];
    const capturedId = id;
    const capturedUndoParams = {
      [SOURCE.bookstat]: { amazonasin: book.ASIN },
      [SOURCE.ao3]: { work_id: book['work_id'] },
      [SOURCE['royal-road']]: { fiction_id: book['Fiction Id'] }
    }[capturedSource];

    const promise = mutateAsync(body);
    const route = source['source'] === '/ao3' ? 'popular' : 'all-new-titles';
    promise.then(res => {
      if (res?.status === 200) {
        showActionNotification({
          type: 'success',
          message: 'The Title was successfully returned.',
          destination: {
            name: source['source'] === '/ao3' ? 'Popular' : 'All New Titles',
            onGoTo: () => history.push(`${capturedSource}/${route}`)
          },
          onUndo: async () => {
            await bookService.updateTitle(
              {
                source: capturedSource,
                sourceTab: route,
                endpoint: Endpoints[capturedId],
                action: capturedId
              },
              capturedUndoParams
            );
          },
          queryClient,
          id
        });

        if (capturedId === SEND_TO_CRM || capturedId === SENT_TO_CRM_RR || capturedId === SENT_TO_CRM_AO3) {
          showActionNotification({ type: 'info', message: 'Please delete the data from Hubspot.' });
        }
      } else {
        showActionNotification({ type: 'error', message: 'The Title has not been returned.' });
      }
    }).catch(() => {
      showActionNotification({ type: 'error', message: 'The Title has not been returned.' });
    });

    promise.then(() => queryClient.refetchQueries(`get-row-count${id}`));
    promise.then(() => queryClient.refetchQueries(`get-${id}`));
    promise.finally(() => setActionLoading(false));

    handleClose();
  };

  return (
    <Modal
      okText={'Return Title'}
      title='Return Title'
      visible={modal}
      onOk={onSend}
      confirmLoading={isActionLoading}
      onCancel={handleClose}
    >
      <div>
        <span>
          Help yourself and others understand why you&apos;re returning this. Leave a note, or skip and
          continue.
        </span>
        <br />
        <br />
        <TextArea
          placeholder='Add your notes here...'
          maxLength={400}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={4}
        />

        <div style={{ textAlign: 'right', fontSize: 12, marginTop: 4 }}>
          {notes.length} / 400
        </div>
      </div>
    </Modal>
  );
};

export default React.memo(ReturnTitles);
